import styled from 'styled-components';
import { white, indigo, lightPurple, darkOrange, transparentBlack } from '../../../../app/js/components/loggedout/shared-styles/Colors';
import { CTAPrimaryButton } from '../../../../app/js/components/loggedout/shared-styles/CTAPrimaryButton';
import { ContainerWrapper, Heading1, CTAButtonWrapper, OfferText } from "../../common/styled-components/styled-components";
import { breakpoints, device } from '../../../../app/js/utils/responsive_utilities';
import Bg_group_desk from "~images/sem/main-section/bg_group_desk.png";
import Bg_group from "~images/sem/main-section/bg_group_sm.png";
import Bg_design from "~images/sem/main-section/bg_design.png";
import Bg_group3x from "~images/sem/main-section/bg_group_3x.png";

import { fontQuicksand } from '../../common/mixins/mixin';
import { assetPath } from '../../../../app/js/utils/web-helper';

export const Wrapper = styled(ContainerWrapper)`
  @media (min-width: ${breakpoints.lg}px) {
    display: flex;
    padding: 0 13.5rem;
  }

  @media ${device.TabletLandscape}{
    padding: 0 1.5rem;
  }
`

export const ImageWrapper = styled.div`
  width: 28.8rem;
  height: 27.8rem;
  position: relative;
  margin: auto;
  & > img{
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    &.outline-star{
      width: 94%;
      left: 6px;
    }
  }
  @media (min-width: ${breakpoints.lg}px) {
    width: 49rem;
    height: 47rem;
    & > img.outline-star {
      left: 1rem;
  }
}
`

export const CartoonContainer = styled.div`
  width : 9rem;
  height : 9.37rem;
  & > img{
    height:100%;
    width: 100%;
    margin-left: -1.4rem;
    margin-top: 0.68rem;
  }
  @media (min-width: ${breakpoints.lg}px) {
    width: 12.5rem;
    height: 12.5rem;
    & > img {
      margin-left: -.5rem;
      margin-top: 2rem;
    }
  }
`;

export const BackgroundImage = styled.div`
  width: 100%;
  height:100%;
  background: url( ${assetPath(Bg_group)}) 0 -7rem/cover no-repeat;

  @media (min-width : ${breakpoints.sm}px){
    background: url( ${assetPath(Bg_group3x)}) 0 -41.6rem/cover no-repeat;
  }

  @media (min-width: ${breakpoints.lg}px) {
    background: url( ${assetPath(Bg_group_desk)}) 0 -4rem/cover no-repeat;
    background-size: 100%;
    flex-basis: 50%;
    padding: 7.8rem 0 7rem;
  }
`;

export const BackgroundCurve = styled.div`
  background: url(${assetPath(Bg_design)});
  height: 24rem;
  background-repeat: no-repeat;
  padding: 0.5rem;
  background-size: 100% 100%;
  margin-top: -3rem;
  @media (min-width: ${breakpoints.lg}px) {
    background: none;
    flex-basis: 50%;
    height: auto;
    padding: 5.5rem 0 7rem;
    margin-top: 0;
  }
`

export const ContentWrapper = styled.div`
  font-size: 1.5rem;
  display: flex;
  flex-direction: column;
  & > * {
    flex: 1;
  }
`;

export const ContentTitle = styled(Heading1)`
  color: ${white};
  ${fontQuicksand(2.2, 2.7, 7)}
  text-align: center;
  ${props => props.curveTitle ? 'display: none;' : ''};
  width: 90%;
  margin: 1rem auto;
  @media (min-width: ${breakpoints.lg}px) {
    display: block;
    width: 100%;
    ${props => props.curveTitle ? fontQuicksand(3.2, 4, 7) : 'display: none;'}
    order: 2;
    margin: 1rem auto 0;
    max-width: 53rem;
  }
`;

export const Stripe = styled.div`
  background: ${lightPurple};
  border-radius: .2rem;
  padding: 0.64rem;
  & > p {
    color: ${white};
    ${fontQuicksand(1.4, 1.6, 7)}
    text-align: center;
    margin: 0;
  }
  ${props => props.curveStripe ? 'display: none;' : ''}
  @media (min-width: ${breakpoints.lg}px) {
    ${props => props.curveStripe ?
    `
        background: none;
        display: block;
        & > p {
          order: 1;
          background-position: 100% 100%;
          margin: 0 auto;
          width: 47rem;
          padding: 1.6rem 2.3rem 0;
          ${fontQuicksand(1.6, 2, 7)}
          box-sizing: border-box;
        }
      ` :
    'display: none'
  };
  }
`;

export const ExtraInfoWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 3.2rem;
  padding: .5rem;
  margin-bottom: 3rem;

  @media (min-width: ${breakpoints.lg}px) {
    flex-direction: column;
  }
`;

export const ExtraInfo = styled.div`
  display: flex;
  flex-basis: 10rem;
  p{
      margin: 0;
  }
  &:nth-child(1) {
    flex-direction: column;
    flex-basis: 6.88rem;   
    & > div:nth-child(2) {
      top: .6rem;
    }
  }
  @media (min-width: ${breakpoints.lg}px) {
    flex: 1;
    align-items: center;
    justify-content: flex-start;
    width: 33.5rem;
    margin: 2rem auto 0;
    &:nth-child(1) {
      flex-direction: row;
      flex-basis: unset;
      margin-top: 0;
      img{
        width:7rem;
        position: relative;
        left: -.9rem;
      }
    }
  }
`;

export const InfoIcon = styled.div`
  width: 5rem;
  height: 3.8rem;
  img {
    width: 3.8rem;
    height: 3.8rem;
  }
  p{
    color: ${darkOrange};
    ${fontQuicksand(1.6, 1.8, 7)}
    margin: 0;
    max-height: 2rem;
    ${props => props.firstInfoIcon === 'text' ? 'position: relative;bottom: 14px;' : ""}
  }
  ${props => props.firstInfoIcon === 'img' ? 'display: none;' : 'display: block;position: relative;bottom: 3px;'}

  @media (min-width: ${breakpoints.lg}px) {
    width: 8rem;
    height: 5rem;
    flex-basis: unset;

    ${props => props.firstInfoIcon === 'text' ? 'display: none;' : 'display: inline-block;'}
    img {
      width: 5rem;
      height: 5rem;
    }
  }
`;

export const Info = styled.div`
  flex-basis: 60%;
  ${fontQuicksand(1.1, 1.6, 5)}
  color: ${white};
  position: relative;
  p{
    position: absolute;
    bottom: ${props => props.bottomText ? '-.3rem' : '-.2rem'};
  }
  @media (min-width: ${breakpoints.lg}px) {
    flex-basis: unset;
    ${fontQuicksand(2, 2.4, 5)}
    p {
      position: relative;
      bottom: -.2rem;
    }
  }
`;

export const ButtonWrapper = styled(CTAButtonWrapper)``

export const CTAOfferButton = styled(CTAPrimaryButton)`
  background : ${white};
  width: 32rem;
  a{
    color : ${indigo};
    font-weight: bold;
    font-size: 1.8rem;
    text-align: center;
  }
`;

export const PlayButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  background : ${transparentBlack};
  position: absolute;
  width: 12.8rem;
  height: 8.96rem;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  justify-content: center;
  align-items: center;
  border-radius: 0.8rem;
  cursor: pointer;
  p{
    color: white;
    margin: 0;
    ${fontQuicksand(1.2, 1.4, 7)}
    padding-top: 0.8rem;
  }
`;

export const PlayButton = styled.div`
  width: 0;
  height: 0;
  border-top: 2.5rem solid transparent;
  border-left: 3.5rem solid ${white};
  border-bottom: 2.5rem solid transparent;
  color:${white};
  border-radius: .7rem;
`;

export const CurveOfferText = styled(OfferText)`
  @media (min-width: ${breakpoints.lg}px) {
    ${fontQuicksand(1.6, 2, 7)}
  }
`;
